import { Injectable, signal } from '@angular/core';

import { ProgramTemplate } from '@libs/src/models/program-template.model';

@Injectable({ providedIn: 'root' })
export class CreateDevelopmentProgramStateService {
  temporaryProgramTemplatesMap = signal<Record<string, ProgramTemplate>>({});

  addTemporaryProgramTemplate(key: string, programTemplate: ProgramTemplate) {
    this.temporaryProgramTemplatesMap.update((value) => ({
      ...value,
      [key]: programTemplate,
    }));
  }

  removeTemporaryProgramTemplate(key: string) {
    this.temporaryProgramTemplatesMap.update((value) => {
      const newValue = { ...value };
      delete newValue[key];
      return newValue;
    });
  }

  getTemporaryProgramTemplate(key: string): ProgramTemplate | undefined {
    return this.temporaryProgramTemplatesMap()[key];
  }
}
